// youtube-api.js
const API_KEY = 'AIzaSyAaH2glCEHePc8ZZkrcWHg1Em3xUqquT4c';
const CHANNEL_ID = 'UCrImdWXY413OcMBKaf_7GNw';

const API_ENDPOINT = `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${CHANNEL_ID}&order=date&part=snippet&type=video&videoDuration=medium`;

fetch(API_ENDPOINT)
  .then(response => response.json())
  .then(data => {
    const latestVideoId = data.items[0].id.videoId;
    const latestVideoUrl = `https://www.youtube.com/watch?v=${latestVideoId}`;
    updateYouTubeButton(latestVideoUrl);
  })
  .catch(error => {
    console.error('Error fetching latest video:', error);
  });

function updateYouTubeButton(videoUrl) {
  const youtubeButton = document.getElementById('youtubeButton'); // Replace with your button's ID
  youtubeButton.addEventListener('click', function() {
    window.location.href = videoUrl;
  });
}